import { render, staticRenderFns } from "./ReceiveDispatch.vue?vue&type=template&id=5c41ef1c"
import script from "./ReceiveDispatch.vue?vue&type=script&lang=js"
export * from "./ReceiveDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports